import anime from 'animejs/lib/anime.es.js';

export const animateGridItem = selector =>
  window.Shopify.designMode !== true &&
  anime({
    targets: selector,
    translateY: [60, 0],
    opacity: 1,
    easing: 'cubicBezier(.5, .05, .1, .3)',
    duration: 400,
    delay: anime.stagger(200),
  });
